import { IF, Tooltip } from '../../common';

const TruncateText = ({
  text,
  limit = 20,
  style = {},
  className = 'body-12-medium',
  textClassName = '',
  showTooltip = true,
}) => {
  const displayText = text?.length > limit ? text.slice(0, limit) + '...' : text;

  return (
    <div className={className} style={style}>
      <IF condition={text?.length > limit} ELSE={<span className={textClassName}>{text}</span>}>
        <IF condition={showTooltip} ELSE={<span className={textClassName}>{displayText}</span>}>
          <Tooltip title={text}>
            <span className={textClassName}>{displayText}</span>
          </Tooltip>
        </IF>
      </IF>
    </div>
  );
};

export default TruncateText;
